<template>
  <div>
    <contacts-edit :contact="contact" v-if="contact" />
  </div>
</template>

<script>
import ContactsEdit from '@/plus/components/Contacts/Edit'
import ContactsEditMixin from '@/common/mixins/views/ContactsEdit.mixin'

export default {
  name: 'ContactsEditView',
  mixins: [ContactsEditMixin],
  components: { ContactsEdit }
}
</script>
